
import { tagableMixin, campaignMixin } from "~/mixins";

export default {
  mixins: [tagableMixin, campaignMixin],

  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
    minPriceVariant: { type: Object, default: () => {} },
  },

  computed: {
    compareAtPrice() {
      return (
        (this.minPriceVariant ?? this.selectedVariant)?.compareAtPrice ?? 0
      );
    },
    price() {
      return (this.minPriceVariant ?? this.selectedVariant)?.price ?? 0;
    },
    tags() {
      return this.product?.tags ?? [];
    },
    saleTagText() {
      return this.priorityCampaign.value?.saleTileTitle;
    },
    saleTagTextMobile() {
      return this.priorityCampaign.value?.saleTileTitleMobile;
    },
  },
};
